// Human-friendly labels for the internal skip_reason / failure codes
// produced by the Communication backend (Pass E §18).
//
// Backend continues to emit precise codes so logs stay diagnosable;
// the UI never leaks a raw provider stack trace or the exact internal
// enum. Unknown codes fall back to a tidy title-cased rendering so a
// future backend code doesn't render as blank.

const MAP: Record<string, string> = {
  suppressed:                   "Marketing opt-out",
  consent_unknown:              "Consent not on file",
  no_consent_on_file:           "Consent not on file",
  consent_expired:              "Consent expired",
  unsubscribed_after_snapshot:  "Recipient unsubscribed after campaign was prepared",
  template_render_error:        "Template could not be rendered",
  missing_sender_account:       "Microsoft 365 sender account unavailable",
  graph_auth_error:             "Microsoft 365 authentication error",
  graph_rejected:               "Microsoft 365 rejected the message",
  intalk_rejected:              "INTALK rejected the message",
  invalid_email:                "Invalid email address",
  invalid_phone:                "Invalid phone number",
  invalid_contact:              "Invalid contact",
  missing_contact:              "Missing contact information",
  duplicate_in_campaign:        "Duplicate recipient",
  queue_failure:                "Queue processing failed",
  provider_timeout:             "Provider request timed out",
  unknown_provider_state:       "Provider result could not be confirmed",
};

export function failureLabel(code: string | null | undefined): string {
  if (! code) return "";
  const c = code.toLowerCase();
  if (MAP[c]) return MAP[c];
  // Fallback: title-case with spaces so a future backend code renders
  // as "some new reason" instead of the raw enum.
  return c.replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());
}
